// GlobalDialog.tsx
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Button } from "../ui/button";

interface GlobalDialogProps {
  open: boolean;
  title?: string;
  content?: React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
}

const GlobalDialog: React.FC<GlobalDialogProps> = ({
  open,
  title,
  content,
  onClose,
  onConfirm,
  confirmText = "OK",
  cancelText = "Cancel",
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{content}</DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Button onClick={onClose} variant="error">{cancelText}</Button>
        {onConfirm && <Button onClick={onConfirm} variant="default">{confirmText}</Button>}
      </DialogActions>
    </Dialog>
  );
};

export default GlobalDialog;
